import type { Phrases } from '../Phrases.d';
import type { IntoxicantOption } from '../../../../../site/parts/notificationFormAnonymous/IntoxicantOption.d';

import React, { useEffect, useRef } from 'react';
import { Row } from '/react4xp/components/Flex';
import { Fieldset } from '/react4xp/components/react-hook-form/Fieldset';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { SubstanceAutoComplete } from './SubstanceAutoComplete';
import { SubstanceDetailsTextField } from './SubstanceDetailsTextField';
import { SubstanceOtherButton } from './SubstanceOtherButton';
import { SubstanceOtherTextField } from './SubstanceOtherTextField';
import {
	COMMON_FIELD_NAME,
	SUBSTANCE_LEGEND_ID,
} from '../constants';


export const SubstanceFieldset = ({
	intoxicantOptions,
	phrases,
}: {
	intoxicantOptions: IntoxicantOption[];
	phrases: Phrases;
}): React.JSX.Element => {
	const legend = phrases['notificationForm.common.substanceField.label'];
	const scrollRef = useRef();

	const {
		setScrollRef,
	} = useFormContext();

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({ field: COMMON_FIELD_NAME.SUBSTANCE, el: scrollRef.current });
			setScrollRef({ field: COMMON_FIELD_NAME.SUBSTANCE_OTHER, el: scrollRef.current });
		}
	}, [scrollRef.current]);

	return (
		<Fieldset
			borderless
			legend={legend}
			legendId={SUBSTANCE_LEGEND_ID}
			legendRef={scrollRef}
			name={COMMON_FIELD_NAME.SUBSTANCE}
			required
		>
			<Row className='gap-sm'>
				<SubstanceAutoComplete
					intoxicantOptions={intoxicantOptions}
					phrases={phrases}
				/>
				<SubstanceOtherButton
					phrases={phrases}
				/>
			</Row>
			<SubstanceDetailsTextField
				phrases={phrases}
			/>
			<SubstanceOtherTextField
				intoxicantOptions={intoxicantOptions}
				phrases={phrases}
			/>
		</Fieldset>
	);
};
